import { render, staticRenderFns } from "./PresellOrder.vue?vue&type=template&id=2cf2d4fd&scoped=true"
import script from "./PresellOrder.vue?vue&type=script&lang=js"
export * from "./PresellOrder.vue?vue&type=script&lang=js"
import style0 from "./PresellOrder.vue?vue&type=style&index=0&id=2cf2d4fd&prod&scoped=true&lang=scss"
import style1 from "./PresellOrder.vue?vue&type=style&index=1&id=2cf2d4fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2d4fd",
  null
  
)

export default component.exports